module.exports = __webpack_public_path__ + "img/banorte.d92e2de.png";